<template>
  <div>
    <hr class="my-3" />
    <div class="d-flex">
      <mdicon
        class="icon-comment"
        size="25"
        name="message-reply-text-outline"
      />
      <div class="ml-2 title-comment">
        <span> Comentado por </span>
        <strong>{{ comment.name }}</strong>
        <span>
          - {{ comment.dateRegister | formatDateTime }}</span
        >
      </div>
    </div>
    <div class="description-comment">
      {{ comment.description }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["comment"],
};
</script>


<style>
.title-comment {
  color: #545454;
  font-size: 0.9rem;
}

.description-comment {
  padding: 5px 35px;
}
</style>